import { Component, defineAsyncComponent } from 'vue';
import { ModalCode } from './ModalCode';

export const modalRegistry: Record<ModalCode, ModalEntry> = {
    [ModalCode.Login]: defineAsyncComponent(() => import('./components/LoginModal.vue')),
    [ModalCode.Register]: defineAsyncComponent(() => import('./components/RegisterModal.vue')),
    [ModalCode.SearchPlayer]: defineAsyncComponent(() => import('./components/SearchPlayerModal.vue')),
    [ModalCode.Onboarding]: defineAsyncComponent(() => import('./components/OnboardingModal.vue')),
    [ModalCode.PwaInstall]: defineAsyncComponent(() => import('./components/PwaInstallModal.vue')),
    [ModalCode.AdminList]: defineAsyncComponent(() => import('./components/AdminListModal.vue')),
    [ModalCode.ResetPassword]: defineAsyncComponent(() => import('./components/ResetPasswordModal.vue')),
    [ModalCode.MessagePlayers]: defineAsyncComponent(() => import('./components/GameMessageModal.vue')),
    [ModalCode.ConfirmDelete]: defineAsyncComponent(() => import('./components/ConfirmModal.vue')),
    [ModalCode.SetTheme]: defineAsyncComponent(() => import('./components/ThemeModal.vue')),
    [ModalCode.InsertLinkModal]: defineAsyncComponent(() => import('./components/InsertLinkModal.vue')),
    [ModalCode.BecomeMember]: defineAsyncComponent(() => import('./components/BecomeMemberModal.vue')),
    [ModalCode.EndMembership]: defineAsyncComponent(() => import('./components/EndMembershipModal.vue')),
    [ModalCode.AdjustMembershipType]: defineAsyncComponent(() => import('./components/AdjustMembershipModal.vue')),
    [ModalCode.UpdateMembershipStart]: defineAsyncComponent(() => import('./components/UpdateMembershipStartModal.vue')),
    [ModalCode.GmTermsAndConditions]: defineAsyncComponent(() => import('./components/GmTermsAndConditionsModal.vue')),
    [ModalCode.AwardBadge]: defineAsyncComponent(() => import('./components/AwardBadgeModal.vue')),
    [ModalCode.RemoveBadge]: defineAsyncComponent(() => import('./components/RemoveBadgeModal.vue')),
    [ModalCode.BadgeInfo]: defineAsyncComponent(() => import('./components/BadgeInfoModal.vue')),
    [ModalCode.StreakInfo]: defineAsyncComponent(() => import('./components/StreakInfoModal.vue')),
    [ModalCode.AnalyticsConsent]: defineAsyncComponent(() => import('./components/AnalyticsConsentModal.vue')),
};

type ModalEntry = Component;
